import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

const OurApproach = lazy(() => import("../pages/our-approach/page"));
const MarginIntegrityReview = lazy(() => import("../pages/margin-integrity-review/page"));
const Contact = lazy(() => import("../pages/contact/page"));
const WhoWeWorkWith = lazy(() => import("../pages/who-we-work-with/page"));
const About = lazy(() => import("../pages/about/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/our-approach",
    element: <OurApproach />,
  },
  {
    path: "/margin-integrity-review",
    element: <MarginIntegrityReview />,
  },
  {
    path: "/who-we-work-with",
    element: <WhoWeWorkWith />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
